'use strict';

var JumpToNextSection = require('./JumpToNextSection.js');
var ComponentManager = require('../lib/ComponentManager.js');


/**
 * @class
 */
function IntroSection(containerElement) {
	this._containerElement = containerElement;
	
	var jumpToNextSectionElem = this._containerElement.querySelector('.' + JumpToNextSection.COMPONENT_STYLE_CLASS);
	if (jumpToNextSectionElem !== null) {
		var jumpToNextSection = ComponentManager.getInstance().getInstanceForElement(jumpToNextSectionElem, JumpToNextSection.COMPONENT_STYLE_CLASS);
		if (jumpToNextSection !== undefined) {
			setTimeout(jumpToNextSection.start, 550);
		}
	}
}

/**
 * @public
 */
IntroSection.prototype.destroy = function() {
	// Delete DOM references
	delete this._containerElement;
}

IntroSection.COMPONENT_STYLE_CLASS = 'introSection';

module.exports = IntroSection;

